<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Company management'"></page-title>
    </div>

    @if (canCreate()) {
      <a mat-raised-button color="primary" routerLink="/companies/new">Create company</a>
    }
  </div>

  <company-table
    [companies]="companyStore.companies()"
    [loading]="companyStore.loading()"
    [canDeactivate]="canDeactivate()"
    [canActivate]="canActivate()"
    [canUpdate]="canUpdate()"
    [actionCompanyId]="actionCompanyId()"
    (toggled)="toggleCompanyActive($event)" />
</section>